import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useApiStore from '../apiStore/useApiStore';
import { keysToPersist, leadChannelStore } from './leadChannelStore';

const useLeadChannelStore = createStore({
  creator: leadChannelStore({
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'leadChannel',
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        return pickState(state, keysToPersist);
      },
    },
  },
});

export default useLeadChannelStore;
